import { AuthGuard } from '@app/auth.guard';
import { LoginComponent } from '@app/account/login/login.component';
import { MainmenuComponent } from './mainmenu/mainmenu.component';
import { ContactComponent } from './contact/contact.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { SocialMediaMonitorComponent } from './social-media-monitor/social-media-monitor.component';
import { KnowledgeBaseComponent } from './knowledge-base/knowledge-base.component';
import { ReportComponent } from './report/report.component';
import { NewsComponent } from './news/news.component';
import { CaseComponent } from './case/case.component';
import { SharedCaseComponent } from './shared-case/shared-case.component';
import { NewCaseComponent } from './new-case/new-case.component';
import { CustomerComponent } from './customer/customer.component';
import { ForgotPasswordComponent } from './account/forgot-password/forgot-password.component';
import { IncomingCallComponent } from './incoming-call/incoming-call.component';
import { IncomingContactComponent } from './incoming-contact/incoming-contact.component';
import { PoolCaseComponent } from './pool-case/pool-case.component';
import { DownloadFileComponent } from './download-file/download-file.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { SetChangePasswordComponent } from './set-change-password/set-change-password.component';
import { CreateNewPasswordComponent } from './create-new-password/create-new-password.component';
import { CustomerEditComponent } from './customerEdit/customerEdit.component';
var appRoutes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'login', component: LoginComponent
    },
    {
        path: 'mainmenu', component: MainmenuComponent,
        children: [
            { path: 'pool', component: PoolCaseComponent, canActivate: [AuthGuard] },
            { path: 'shared', component: SharedCaseComponent, canActivate: [AuthGuard] },
            { path: 'case', component: CaseComponent, canActivate: [AuthGuard] },
            { path: 'contact', component: ContactComponent, canActivate: [AuthGuard] },
            { path: 'chatbot', component: ChatbotComponent, canActivate: [AuthGuard] },
            { path: 'socialMedia', component: SocialMediaMonitorComponent, canActivate: [AuthGuard] },
            { path: 'knowledge', component: KnowledgeBaseComponent, canActivate: [AuthGuard] },
            { path: 'report', component: ReportComponent, canActivate: [AuthGuard] },
        ]
    },
    {
        path: 'news/:id', component: NewsComponent, canActivate: [AuthGuard]
    },
    {
        path: 'customer/:id', component: CustomerComponent, canActivate: [AuthGuard]
    },
    {
        path: 'newCase', component: NewCaseComponent, canActivate: [AuthGuard]
    },
    {
        path: 'newCaseChatbot', component: NewCaseComponent, canActivate: [AuthGuard]
    },
    {
        path: 'caseDetail/:id', component: NewCaseComponent, canActivate: [AuthGuard]
    },
    {
        path: 'newContact', component: NewCaseComponent, canActivate: [AuthGuard]
    },
    {
        path: 'newCaseForContact/:id', component: NewCaseComponent, canActivate: [AuthGuard]
    },
    {
        path: 'changePassword', component: ForgotPasswordComponent, canActivate: [AuthGuard]
    },
    {
        path: 'resetPassword', component: ResetPasswordComponent
    },
    {
        path: 'setNewPassword', component: SetNewPasswordComponent
    },
    {
        path: 'customerEdit', component: CustomerEditComponent
    },
    {
        path: 'setChangePassword', component: SetChangePasswordComponent
    },
    {
        path: 'createNewPassword', component: CreateNewPasswordComponent
    },
    {
        path: 'incomingCall', component: IncomingCallComponent, canActivate: [AuthGuard]
    },
    {
        path: 'incomingContact', component: IncomingContactComponent, canActivate: [AuthGuard]
    },
    {
        path: 'downloadFile', component: DownloadFileComponent, canActivate: [AuthGuard]
    },
];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js